import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteItems', {
    sectionName: 'Items',
    itemColumnName: 'Item',
    itemFieldPlaceholder: 'Select item',
    descriptionColumnName: 'Description',
    descriptionFieldPlaceholder: 'Enter description',
    qtyColumnName: 'QTY',
    qtyFieldPlaceholder: 'Enter value',
    unitPriceColumnName: 'Rate',
    unitPriceFieldPlaceholder: 'Enter value',
    amountColumnName: 'Amount',
    amountFieldPlaceholder: 'Enter amount',
    taxCodeColumnName: 'Tax code',
    taxCodeFieldPlaceholder: 'Select tax code',
    taxRateColumnName: 'Tax rate',
    taxAmountColumnName: 'Tax amount',
    grossAmountColumnName: 'Gross amount',
    grossAmountFieldPlaceholder: 'Enter gross amount',
    memoColumnName: 'Memo',
    departmentColumnName: 'Department',
    departmentFieldPlaceholder: 'Select department',
    classColumnName: 'Class',
    classFieldPlaceholder: 'Select class',
    locationColumnName: 'Location',
    locationFieldPlaceholder: 'Select location',
    customerColumnName: 'Customer:Project',
    customerFieldPlaceholder: 'Select value',
    projectTaskColumnName: 'Project Task',
    projectTaskFieldPlaceholder: 'Select value',
    billableColumnName: 'Billable',
    billableColumnTooltip: 'This line is billable',
    closedColumnName: 'Closed',
    closedColumnTooltip: 'This line is closed',
    unitsColumnName: 'Units',
    unitsFieldPlaceholder: 'Select units',
    vendorNameColumnName: 'Vendor Name',
    expectedReceiptDateColumnName: 'Expected Receipt Date',
    expectedReceiptDatePlaceholder: 'Select date',
    inputPlaceholder: 'Enter value',
    datePlaceholder: 'Select date',
    amortizationSchedule: 'Amortization Schedule',
    amortizationStartDate: 'Amortization Start Date',
    amortizationEndDate: 'Amortization End Date',
    amortizationResidual: 'Amortization Residual',
    groupEdit: 'Edit selected',
    groupClone: 'Clone selected',
    groupRemove: 'Remove selected',
});
